import $ from 'jquery';
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';

import {
    faBars,
    faSearchPlus,
    faSearch,
    faFile,
    faFilePdf,
    faChevronRight,
    faChevronLeft,
    faChevronDown,
} from '@fortawesome/pro-regular-svg-icons';

import { faHome } from '@fortawesome/pro-light-svg-icons';

import {
    faFileImage,
    faGlobe

} from '@fortawesome/pro-light-svg-icons';

import {
    // concrete5 icons - don't remove.
    faArrows,
    faShareAlt,
    faAngleRight,
    faArrowRight,
    faArrowLeft,
    faSpinnerThird,
    faTimes,
    faCaretRight,
    faCaretLeft,
    faMapMarkerAlt
} from '@fortawesome/pro-solid-svg-icons';

import {
    faFacebookF,
    faLinkedinIn
} from '@fortawesome/free-brands-svg-icons';
// Example custom phone icon
// Use it this way: <i class="custom fa-phone"></i>
import phone from './icons/phone';
import phone2 from './icons/phone2';

config.searchPseudoElements = true;

library.add(
    faBars,
    faArrows,
    faShareAlt,
    faAngleRight,
    faArrowRight,
    faArrowLeft,
    faSpinnerThird,
    faTimes,
    faHome,
    faSearchPlus,
    faSearch,
    faCaretRight,
    faCaretLeft,
    faMapMarkerAlt,
    faFile,
    faFilePdf,
    faFileImage,
    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faGlobe,
    faFacebookF,
    faLinkedinIn,
    phone,
    phone2,

);

// dom.i2svg({node: $('.ccm-page').get(0)});

dom.watch({
    autoReplaceSvgRoot: $('.ccm-page').get(0),
    observeMutationsRoot: $('.ccm-page').get(0)
});

export { dom };
